import { render, staticRenderFns } from "./LocationSleepingClientsOnListDashboard.vue?vue&type=template&id=0dd82943&"
import script from "./LocationSleepingClientsOnListDashboard.vue?vue&type=script&lang=js&"
export * from "./LocationSleepingClientsOnListDashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports